<template>
	<Modal
	v-model="isShow"
  :width="640"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
	>
	<h3 slot="header" class="modal-header">重新添加自如智能设备</h3>
	<ul class="list">
		<li>
			<label>房间：</label>
			<span>{{detailData.stockNum}}</span>
		</li>
		<li>
			<label>智能设备名称：</label>
			<span>{{detailData.deviceType}}</span>
		</li>
		<li>
			<label>智能设备位置：</label>
			<span>{{detailData.areaTypeCode}}</span>
		</li>
	</ul>
	</Modal>
</template>

<script>
import{reOrder,getWorkOrderByFid} from 'api/smartWorkOrder'
export default {
	props: {
    n: {
      type: Number,
      default: 0
		},
		fid:{
			type:String,
			default:''
		}
	},
	data(){
		return{
			loading:false,
			isShow:false,
			nums:'',
			detailData:{
				stockNum:'',
				deviceType:'',
				areaTypeCode:''
			},
		}
	},
	watch:{
		n(){
			this.isShow = true;
			this.getDetail();

		}
	},
	methods:{
		getDetail(){
			getWorkOrderByFid({fid:this.fid})
			.then(res=>{
				this.detailData = res.data;
				this.nums  = this.detailData.stockNum;
			})
		},
		ok(){
			reOrder({
				fid:this.fid
			})
			.then(res=>{
				if(res.code === 0){
					this.$emit('refresh')
					this.$Message.success('添加成功')
				}  else{
					this.$emit('refresh')
				}
			})
			.catch(res=>{
				this.$emit('refresh')
				// this.$Message.error('房间'+this.nums+'添加自如只能设备失败')
			})
		},

	}
}
</script>

<style  scoped>
	.list li{
		font-size:14px;
		height: 30px;
	}
</style>